"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden lg:flex">
        <NavigationMenuList className="gap-8">
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative text-sm font-medium uppercase tracking-wider text-foreground transition-colors duration-[var(--duration-medium)] hover:text-accent-dark focus:text-accent-dark hover:!bg-transparent focus:!bg-transparent after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-accent after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full focus:after:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="lg:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="h-6 w-6 text-foreground" /> : <Menu className="h-6 w-6 text-foreground" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="fixed inset-0 top-[64px] z-40 bg-background/95 backdrop-blur-md lg:hidden">
          <nav className="container mx-auto px-6 py-8">
            <ul className="flex flex-col gap-6">
              {menuItems.map((item, i) => <li key={item.id} data-index={i}>
                  <Link to={item.href || "#"} className="block text-lg font-medium uppercase tracking-wider text-foreground transition-colors duration-[var(--duration-medium)] hover:text-accent-dark focus:text-accent-dark" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-16 backdrop-blur-md bg-background/90 border-b border-border" : "h-[90px] bg-background"}`}>
      <div className="container mx-auto px-6 h-full flex items-center justify-between">
        {}
        <Link to="/HomePage#" className="flex-shrink-0">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542976/img/image_v9bk1gqx.png" alt="DealForge Real Estate Advisory" className="h-12" />
        </Link>

        {}
        <MenuProvider menu_id="3" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <Button asChild className="hidden lg:inline-flex border-2 border-accent bg-transparent text-accent hover:bg-accent hover:text-foreground hover:scale-[1.02] hover:shadow-medium active:scale-[0.98] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:!bg-accent focus:!bg-accent focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2">
          <Link to="#contact">Start a Conversation</Link>
        </Button>
      </div>
    </header>;
}